import { Layout } from "../components/Layout.js";
import { Button } from "../components/Button.js";
import { useScreener } from "../state.js";
import { useFlow } from "./useFlow.js";

export function Welcome() {
  const { patient, config } = useScreener();
  const { go } = useFlow();
  const firstName = patient.name?.split(" ")[0];

  return (
    <Layout step="welcome">
      <div className="screen-illustration" aria-hidden>
        <WelcomeIllustration />
      </div>
      <h1 className="center">
        {firstName ? `Hello ${firstName}, let's check your hearing` : "Check your hearing online"}
      </h1>
      <p className="muted center screen-copy">
        In about 3 minutes you'll find out how well you hear the pitches used in
        everyday listening. You'll adjust soft tones in each ear and answer a
        few quick questions.
      </p>

      <ul className="checklist">
        <li>
          <span className="icon-tile">
            <HeadphonesIcon />
          </span>
          <div>
            <strong>Use headphones or earphones</strong>
            <div className="muted">Wired headphones give the most reliable result.</div>
          </div>
        </li>
        <li>
          <span className="icon-tile">
            <QuietIcon />
          </span>
          <div>
            <strong>Find a quiet place</strong>
            <div className="muted">Somewhere without background noise or distractions.</div>
          </div>
        </li>
        <li>
          <span className="icon-tile">
            <ClockIcon />
          </span>
          <div>
            <strong>Set aside ~5 minutes</strong>
            <div className="muted">You can do the whole check in one sitting.</div>
          </div>
        </li>
      </ul>

      <div className="actions center-actions">
        <Button onClick={() => go("headphones")}>Start the hearing check</Button>
      </div>

      <p className="center muted privacy-copy">
        Your answers and results are shared only with the{" "}
        {config?.brand?.teamName ?? "Hearing Expert audiology team"} to follow up
        on your screening.
      </p>
    </Layout>
  );
}

function WelcomeIllustration() {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none">
      <circle cx="48" cy="48" r="44" fill="var(--primary-soft)" />
      <path
        d="M30 48h6l5-12 8 26 7-20 4 6h6"
        stroke="var(--primary-color)"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

function HeadphonesIcon() {
  return (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M4 14v-2a8 8 0 0116 0v2" stroke="currentColor" strokeWidth="1.8" />
      <rect x="3" y="13" width="4" height="7" rx="2" fill="currentColor" />
      <rect x="17" y="13" width="4" height="7" rx="2" fill="currentColor" />
    </svg>
  );
}

function QuietIcon() {
  return (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M5 9v6h4l5 4V5L9 9H5zM18 9l3 6M21 9l-3 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="13" r="8" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9 2h6M12 5v2M12 13l3 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
